import {
  GET_CAMPUSES_AND_ABSENCES_PENDING,
  GET_CAMPUSES_AND_ABSENCES_FAIL,
  GET_CAMPUSES_FOR_ABSENCES_SUCCESS,
  GET_ACTIVE_ABSENCES_PENDING,
  GET_ACTIVE_ABSENCES_SUCCESS,
  GET_ACTIVE_ABSENCES_FAIL,
  CLEAR_ABSENCES_REDUCER,
} from '../constants/ActionTypes';

export const initialState = {
  campuses: [],
  absences: [],
  isLoading: false,
  pageCount: 1,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPUSES_AND_ABSENCES_PENDING:
    case GET_ACTIVE_ABSENCES_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_ACTIVE_ABSENCES_SUCCESS:
      return {
        ...state,
        absences: action.payload.absences,
        pageCount: action.payload.pageCount,
        isLoading: false,
      };
    case GET_CAMPUSES_FOR_ABSENCES_SUCCESS:
      return {
        ...state,
        campuses: action.payload.campuses,
        isLoading: false,
      };
    case GET_CAMPUSES_AND_ABSENCES_FAIL:
    case GET_ACTIVE_ABSENCES_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case CLEAR_ABSENCES_REDUCER:
      return initialState;
    default:
      return state;
  }
};
